import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=6164996c&scoped=true&"
import script from "./commonTitle.vue?vue&type=script&lang=js&"
export * from "./commonTitle.vue?vue&type=script&lang=js&"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=6164996c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6164996c",
  null
  
)

export default component.exports